import { render } from "./CustomersList.vue?vue&type=template&id=e9b53fd4&ts=true"
import script from "./CustomersList.vue?vue&type=script&lang=ts"
export * from "./CustomersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__